// Reasoning Gap session types (Intro to AI study). Both types give students the identical
// experience - code + "explain your thinking", then hints about their gap after submitting.
// They differ only server-side, in which ground truth (reference code vs. reference
// reasoning) the gap analysis is anchored on; they are the study's two conditions.
// session.type is VARCHAR(20), hence the short values.
export const REASONING_GAP_TYPES = {
  GapCode: { condition: 'code', label: 'Reasoning Gap: Code Ground Truth' },
  GapThinking: { condition: 'thinking', label: 'Reasoning Gap: Thinking Ground Truth' },
}

export const REASONING_GAP_DEFAULT_TASK = 'CART Regression Tree: best_split'

export function isReasoningGapSession (session) {
  return !!(session && Object.prototype.hasOwnProperty.call(REASONING_GAP_TYPES, session.type))
}
